const SYNOPTIC_OK_CODE = 1;

export {
  SYNOPTIC_OK_CODE
};